module.exports = __webpack_public_path__ + "static/img-8cd5e447abbd9931c90530ebc9f39355.jpeg";